import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

export type PostFusionCertificatePreviewPartner = {
  partnerId: string;
  name: string;
  sharesAtDate: number;
};

export type PostFusionCertificatePreview = {
  totalPartners: number;
  eligibleCount: number;
  skippedCount: number;
  eligiblePartnersSample: PostFusionCertificatePreviewPartner[];
  sampleLimit: number;
  hasMoreEligible: boolean;
};

type GetPostFusionCertificatePreviewProps = {
  societyId: string;
  referenceDate: string;
};

export const getPostFusionCertificatePreview =
  ({ societyId, referenceDate }: GetPostFusionCertificatePreviewProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(
        '/partners/sharesOwnershipCertificate/postFusionPreview',
        {
          params: { societyId, referenceDate },
        }
      );

      const decodedData = await decryptResponse(data);

      return decodedData as PostFusionCertificatePreview;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
